const toNString = (value) => value.replace(/-/g, '');

export {
    toNString
};